export const additionalAttributes = ['target', 'onClick']
